module.exports = __webpack_public_path__ + "img/sm.9f7a149d.svg";